/*
 * Copyright © 2026 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { Outlet, RouteObject } from "react-router-dom";

import { ProtectedRoute } from "../../components/AppRouter/ProtectedRoute";
import { FlagGate, FlagSwitchGate, SelectorGate } from "../../components/AppRouter/route-gates";
import { CheckoutSuccess } from "../../pages/CheckoutSuccess";
import DeprecatedCart from "../../pages/DeprecatedCart";
import { EnquiryRequestSent } from "../../pages/EnquiryRequestSent";
import { HOME_ROUTE } from "../../util/routing";
import { selectCanUseQuickOrder } from "../azure-b2c/storage";
import ShopCartPage from "../shop/pages/ShopCartPage";
import ShopProductDetailsPage from "../shop/pages/ShopProductDetailsPage";

import ProductDetails from "./pages/ProductDetails";
import { ProductNotFound } from "./pages/ProductNotFound";
import Products from "./pages/Products";
import TraderDeals from "./pages/TraderDeals";
import {
  PRODUCT_DETAILS_SEGMENT,
  PRODUCTS_CART_SEGMENT,
  PRODUCTS_CHECKOUT_SEGMENT,
  PRODUCTS_ENQUIRY_REQUEST_SENT,
  PRODUCTS_NOT_FOUND_SEGMENT,
  PRODUCTS_ROUTE_PERMISSION,
  PRODUCTS_ROUTES,
  PRODUCTS_TRADER_DEALS_SEGMENT,
} from "./constants";

export const productsRoutes: RouteObject[] = [
  {
    path: PRODUCTS_ROUTES.BASE,
    element: (
      <ProtectedRoute {...PRODUCTS_ROUTE_PERMISSION} redirectTo={HOME_ROUTE}>
        <Outlet />
      </ProtectedRoute>
    ),
    children: [
      { index: true, element: <Products /> },
      {
        path: PRODUCT_DETAILS_SEGMENT,
        element: (
          <FlagSwitchGate
            flag="enableShopProductDetailsPage"
            flagEnabled={
              <FlagSwitchGate
                flag="enableShopCartPage"
                flagEnabled={<ShopProductDetailsPage />}
                flagDisabled={<ProductDetails />}
              />
            }
            flagDisabled={<ProductDetails />}
          />
        ),
      },
      { path: PRODUCTS_NOT_FOUND_SEGMENT, element: <ProductNotFound /> },
      {
        path: PRODUCTS_TRADER_DEALS_SEGMENT,
        element: (
          <FlagGate flag="traderDealsEnabled" redirectTo={HOME_ROUTE}>
            <TraderDeals />
          </FlagGate>
        ),
      },
      {
        element: <SelectorGate selector={selectCanUseQuickOrder} redirectTo={HOME_ROUTE} />,
        children: [
          {
            path: PRODUCTS_CART_SEGMENT,
            element: (
              <FlagSwitchGate
                flag="enableShopCartPage"
                flagEnabled={<ShopCartPage />}
                flagDisabled={<DeprecatedCart />}
              />
            ),
          },
          { path: PRODUCTS_CHECKOUT_SEGMENT, element: <CheckoutSuccess /> },
        ],
      },
    ],
  },
  {
    element: (
      <ProtectedRoute {...PRODUCTS_ROUTE_PERMISSION} redirectTo={HOME_ROUTE}>
        <Outlet />
      </ProtectedRoute>
    ),
    children: [{ path: PRODUCTS_ENQUIRY_REQUEST_SENT, element: <EnquiryRequestSent /> }],
  },
];
